import { ImageUploadPicker } from '@northladder/design-system';

import { IDeviceImageOptionsWithMetadataTranslations } from '../../types';
import { IntermediateDoneUploading } from '../../components';

import { ImageUploadContent } from '../ImageUploadContent';

interface IDeviceImagePromptItemProps
  extends IDeviceImageOptionsWithMetadataTranslations {
  isUploaded?: boolean;
  onResetUpload?: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * Creates a button prompt with an upload icon and hidden modal which on click
 * opens the modal to allow for the image capture and later upload.
 */
export function DeviceImagePromptItem({
  imageData,
  isUploaded,
  onUpdateImage,
  onResetUpload,
  subTitle,
  title,
  titlePostfix,
}: IDeviceImagePromptItemProps) {
  if (imageData.status?.toLowerCase() === 'completed') {
    return (
      <IntermediateDoneUploading title={title} titlePostfix={titlePostfix} />
    );
  }

  return (
    <ImageUploadPicker
      isUploaded={isUploaded}
      onResetUpload={onResetUpload}
      renderModalContent={({ onCloseModal }) => (
        <ImageUploadContent
          imageData={imageData}
          onCloseModal={onCloseModal}
          onUpdateImage={onUpdateImage}
        />
      )}
      subTitle={subTitle}
      title={title}
      titlePostfix={titlePostfix}
    />
  );
}
